import React from 'react';
import { ChartLineUp } from '@phosphor-icons/react';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ComposedChart, Line, Area } from 'recharts';

const tooltipStyle = {
  backgroundColor: 'hsl(var(--card))',
  border: '1px solid hsl(var(--border))',
  borderRadius: '0.25rem',
};

const ForecastChart = ({ forecast }) => {
  if (!forecast?.forecast?.length) return null;

  return (
    <div className="bg-card border border-border rounded-sm p-6">
      <div className="flex items-center mb-6">
        <ChartLineUp size={24} weight="regular" className="mr-3" />
        <div>
          <div className="text-xl font-semibold tracking-tight">Revenue Forecast</div>
          <div className="text-xs tracking-[0.2em] uppercase text-muted-foreground">
            PREDICTIVE ANALYTICS - {forecast.model_accuracy}% ACCURACY
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={250}>
        <ComposedChart data={[...forecast.historical_data.slice(-3), ...forecast.forecast]}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis dataKey="month" stroke="hsl(var(--foreground))" style={{ fontSize: '12px' }} />
          <YAxis stroke="hsl(var(--foreground))" style={{ fontSize: '12px' }} />
          <Tooltip contentStyle={tooltipStyle} />
          <Area
            type="monotone"
            dataKey="revenue"
            fill="hsl(var(--accent) / 0.2)"
            stroke="hsl(var(--accent))"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="predicted_revenue"
            stroke="hsl(var(--destructive))"
            strokeWidth={2}
            strokeDasharray="5 5"
            dot={{ fill: 'hsl(var(--destructive))', r: 4 }}
          />
        </ComposedChart>
      </ResponsiveContainer>
      <div className="mt-4 grid grid-cols-3 gap-4">
        {forecast.forecast.map((item) => (
          <div key={item.month} className="p-3 bg-muted rounded-sm">
            <div className="text-xs text-muted-foreground">{item.month}</div>
            <div className="text-lg font-semibold">₹{item.predicted_revenue.toLocaleString()}</div>
            <div className="text-xs text-muted-foreground capitalize">{item.confidence} confidence</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ForecastChart;
